import { createContext, ReactNode, useCallback } from 'react';
import { OpenPopupContext } from '../Popup/type';

import { useCreatePopup } from '../useCreatePopup';

export const TooltipContext = createContext<{
  openWithContext: (ctx: OpenPopupContext<ReactNode>) => void;
  forceClose: () => void;
}>({} as any);

export default function ToolTipProvider({ children }: { children: ReactNode }) {
  const TooltipPopup = useCreatePopup<ReactNode>();
  const openWithContext = useCallback(TooltipPopup.openWithContext, []);
  const forceClose = useCallback(TooltipPopup.forceClose, []);

  return (
    <TooltipContext.Provider value={{ openWithContext, forceClose }}>
      {children}
      <TooltipPopup.Component placement="bottom" offset={[0, 8]}>
        {({ data }) => (
          <div
            data-show
            id="tooltip"
            role="tooltip"
            data-popper-arrow
            data-popper-placement="top"
            className="max-w-xs "
          >
            {data}
          </div>
        )}
      </TooltipPopup.Component>
    </TooltipContext.Provider>
  );
}
